export const API_KEY = import.meta.env.VITE_APIKEY;

// Internal urls
export const API_SERVER_DOMAIN =
  import.meta.env.VITE_API_SERVER_DOMAIN || "dashboard.situm.com";
// URLs for tile servers separated by |
export const TILE_SERVER_DOMAIN = (
  import.meta.env.VITE_TILE_SERVER_DOMAIN ||
  "mt0.situm.com|mt1.situm.com|mt2.situm.com"
).split("|");
export const CDN_SERVER_DOMAIN =
  import.meta.env.VITE_CDN_SERVER_DOMAIN || "situm-static.situm.com";

// Customization
export const LOGO: string =
  import.meta.env.VITE_LOGO ||
  "https://situm.com/wp-content/themes/situm/img/logo-situm.svg";
export const DEFAULT_CONFIG_DOMAIN = `https://${API_SERVER_DOMAIN}/api/v1/mapconfig`;
export const NEW_CONFIG_PATH = `/api/v1/map_config`;

// External api keys
export const MAPBOX_API_KEY = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const TINYBIRD_ENDPOINT =
  import.meta.env.VITE_TINYBIRD_ENDPOINT || "https://api.tinybird.co/v0/events";
export const TINYBIRD_CHANNEL = import.meta.env.VITE_TINYBIRD_CHANNEL;
export const TINYBIRD_TOKEN = import.meta.env.VITE_TINYBIRD_TOKEN;

// Analytics configuration
export const ANALYTICS_MODE = import.meta.env.VITE_ANALYTICS_MODE;

// Feature flags
export const ENABLE_PATH_FINDING =
  import.meta.env.VITE_ENABLE_PATH_FINDING === "true" || true;
export const ENABLE_SERVICE_WORKER =
  import.meta.env.MODE === "production" ||
  import.meta.env.VITE_ENABLE_DEV_SERVICE_WORKER === "true";

// External urls
export const INTERNET_CONNECTION_CHECK_URL = `${location.origin}/version.json`;

export const LOW_PERFORMANCE_GPU_VENDOR = "Adreno (TM) 610";

export const INPUT_SEARCH_MAX_LENGTH = 100;

export const TILES_SIZE = 512;
export const MIN_ZOOM_TILES = 18;
export const MAX_ZOOM_TILES = 23;
